export enum FeatureFlag {
  EnablePlanningBooster = 'payments.enable-planning-booster',
}
